import { create } from 'zustand'
import { User, CreateUserDto, UpdateUserDto } from '@/types'
import { usersService } from '@/services/users.service'

interface UsersState {
  users: User[] | null
  isInitialized: boolean
  fetchUsers: () => Promise<void>
  addUser: (user: CreateUserDto) => Promise<User>
  updateUser: (id: string, user: UpdateUserDto) => Promise<User>
  deleteUser: (id: string) => Promise<void>
  getUserById: (id: string) => User | undefined
}

export const useUsersStore = create<UsersState>((set, get) => ({
  users: null,
  isInitialized: false,

  fetchUsers: async () => {
    // Only fetch if not already initialized
    if (get().isInitialized) {
      return
    }

    try {
      const data = await usersService.getNeo()
      set({ users: data, isInitialized: true })
    } catch (error) {
      console.error('Error loading users:', error)
      throw error
    }
  },

  addUser: async (userData: CreateUserDto) => {
    const newUser = await usersService.create(userData)
    set(state => ({
      users: [...state.users || [], newUser],
    }))
    return newUser
  },

  updateUser: async (id: string, userData: UpdateUserDto) => {
    const updatedUser = await usersService.update(id, userData)
    set(state => ({
      users: state.users?.map(user => (user._id === id ? updatedUser : user)),
    }))
    return updatedUser
  },

  deleteUser: async (id: string) => {
    await usersService.delete(id)
    set(state => ({
      users: state.users?.filter(user => user._id !== id),
    }))
  },

  getUserById: (id: string) => {
    return get().users?.find(user => user._id === id)
  },
}))

